import { useTranslation } from "react-i18next";

const steps = [
  { num: "01", key: "how.step1", icon: "ri-list-check-3" },
  { num: "02", key: "how.step2", icon: "ri-search-eye-line" },
  { num: "03", key: "how.step3", icon: "ri-file-info-line" },
  { num: "04", key: "how.step4", icon: "ri-shopping-cart-2-line" },
];

export default function HowSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3 md:mb-4">
            {t("how.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {steps.map((step, idx) => (
            <div key={idx} className="relative text-center group">
              <div className="relative mx-auto mb-5 w-20 h-20 md:w-24 md:h-24 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-300">
                <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-primary-500 text-background-50 text-xs font-bold flex items-center justify-center">
                  {step.num}
                </span>
                <i className={`${step.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>

              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[calc(50%+3rem)] w-[calc(100%-6rem)] h-0.5">
                  <div className="w-full h-full bg-gradient-to-r from-primary-200 to-transparent"></div>
                </div>
              )}

              <p className="text-sm md:text-base font-medium text-foreground-800">
                {t(step.key)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}